// Mobile Menu Handler
// - Toggle-Funktionalität für das Hamburger-Menü
// - Backdrop-Handling zum Schließen
// - Smooth Scroll zu Ankern mit Topbar-Offset

function smoothScrollToTarget(href: string): void {
	// Anchor href auslesen
	if (!href.startsWith('#')) return;
	
	const targetId = href.substring(1);
	const target = document.getElementById(targetId);
	if (!target) return;

	// Topbar-Höhe ermitteln
	const topbar = document.querySelector('.fuelpipe-topbar') as HTMLElement | null;
	const topbarHeight = topbar ? topbar.offsetHeight : 0;

	// Scroll-Position berechnen
	const targetPosition = target.getBoundingClientRect().top + window.scrollY - topbarHeight;

	// Smooth Scroll ausführen
	window.scrollTo({
		top: targetPosition,
		behavior: 'smooth'
	});
}

export function initMobileMenu(): void {
	const toggle = document.querySelector('.menu-toggle') as HTMLElement | null;
	const backdrop = document.querySelector('.menu-backdrop') as HTMLElement | null;
	const navLinks = document.querySelectorAll('.fuelpipe-topbar nav a');

	if (!toggle || !backdrop) return;

	const toggleMenu = () => {
		const isOpen = document.body.classList.toggle('nav-open');
		toggle.classList.toggle('active');
		toggle.setAttribute('aria-expanded', String(isOpen));
	};

	toggle.addEventListener('click', (e) => {
		e.stopPropagation();
		toggleMenu();
	});
	
	backdrop.addEventListener('click', toggleMenu);

	navLinks.forEach(link => {
		link.addEventListener('click', (e) => {
			const href = link.getAttribute('href');
			
			// Wenn es ein Anker ist, smooth scroll triggern
			if (href?.startsWith('#')) {
				e.preventDefault();
				smoothScrollToTarget(href);
			}
			
			// Menü schließen wenn offen
			if (document.body.classList.contains('nav-open')) {
				toggleMenu();
			}
		});
	});
}
